import {
    GET_DOCUMENT_TYPES_FAIL,
    GET_DOCUMENT_TYPES_SUCCESS,
    ADD_DOCUMENT_TYPE_SUCCESS,
    ADD_DOCUMENT_TYPE_FAIL,
    UPDATE_DOCUMENT_TYPE_SUCCESS,
    UPDATE_DOCUMENT_TYPE_FAIL,
    DELETE_DOCUMENT_TYPE_SUCCESS,
    DELETE_DOCUMENT_TYPE_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    documentTypes: [],
    error: null,
    loading: true
};

const documentTypeReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des documentTypes
        case GET_DOCUMENT_TYPES_SUCCESS:
            return {
                ...state,
                documentTypes: action.payload, // tableau d'objetsdocumentType
                loading: false,
                error: null
            };

        case GET_DOCUMENT_TYPES_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'unedocumentTypee
        case ADD_DOCUMENT_TYPE_SUCCESS:
            return {
                ...state,
                documentTypes: [action.payload, ...state.documentTypes], // ajoute au début du tableau
                error: null
            };

        case ADD_DOCUMENT_TYPE_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Mise à jour d'unedocumentTypee
        case UPDATE_DOCUMENT_TYPE_SUCCESS:
            return {
                ...state,
                documentTypes: state.documentTypes.map(documentType =>
                   documentType.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objetdocumentType
                        :documentType
                ),
                error: null
            };

        case UPDATE_DOCUMENT_TYPE_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Suppression d'unedocumentTypee
        case DELETE_DOCUMENT_TYPE_SUCCESS:
            return {
                ...state,
                documentTypes: state.documentTypes.filter(
                   documentType =>documentType.id !== action.payload
                ),
                error: null
            };


        case DELETE_DOCUMENT_TYPE_FAIL:
            return {
                ...state,
                error: action.payload
            };

        default:
            return state;
    }
};

export default documentTypeReducer;
